<template>
  <div v-if="booking_request_submitted">
    <h1>Thank you!</h1>
    <h4>Your booking request has been recieved.</h4>
  </div>
  <div v-else-if="destination && (destination.trip_type==1 || (destination.trip_type==2 && trip))">
    
    <v-stepper v-model="e1" vertical>
      <div class="py-3 pl-3">
        <h1>{{ destination.name }}</h1>
      </div>
      <v-stepper-step :complete="e1 > 1" step="1">ARRIVAL / DEPARTURE</v-stepper-step>
      <v-stepper-content step="1">
        <v-form ref="form_1" v-model="form_1_validation" lazy-validation data-vv-scope="form_1">
          <div v-if="destination.trip_type==2 && trip">
            <v-container fluid grid-list-lg px-2 py-2>
              <v-layout wrap align-center>

                <v-flex xs12 sm6>
                  <select-input :form="form" :items="select_weeks" :v-errors="errors" label="Week" :name="'week'" :scope="'form_1'" v-model="val_trip_week" v-validate="'required'"></select-input>
                </v-flex>

              </v-layout>
            </v-container>
            <v-container fluid grid-list-lg px-2 py-2>
              <v-layout wrap align-center>

                <v-flex xs12 sm6>
                  <select-input :form="form" :items="select_dates" :v-errors="errors" label="Date" :name="'date'" :scope="'form_1'" v-model="val_trip_date" v-validate="'required'"></select-input>
                </v-flex>

              </v-layout>
            </v-container>

            <v-container fluid grid-list-lg px-2 py-2 v-if="val_trip_date=='999'">
              <v-layout wrap align-center>

                <v-flex xs12 sm6>
                  <v-dialog
                    ref="dialogfrom"
                    v-model="modal_date_from"
                    :return-value.sync="form.date_from"
                    persistent
                    lazy
                    full-width
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="form.date_from"
                        label="Arrival date"
                        prepend-icon="event"
                        readonly
                        box
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="form.date_from" scrollable :min="select_date_from_min" :max="select_date_from_max">
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="modal_date_from = false">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.dialogfrom.save(form.date_from)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-dialog
                    ref="dialogto"
                    v-model="modal_date_to"
                    :return-value.sync="form.date_to"
                    persistent
                    lazy
                    full-width
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="form.date_to"
                        label="Departure date"
                        prepend-icon="event"
                        readonly
                        box
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="form.date_to" scrollable :min="select_date_to_min" :max="select_date_to_max">
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="modal_date_to = false">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.dialogto.save(form.date_to)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>

              </v-layout>
            </v-container>
          </div>
          <div v-else-if="destination.trip_type==1">
            <v-container fluid px-2>
              <v-layout wrap align-center>

                <v-flex xs12 sm6>
                  <select-input :form="form" :items="select_trips" :v-errors="errors" label="Date" :name="'date'" :scope="'form_1'" v-model="val_trip" v-validate="'required'"></select-input>
                </v-flex>

              </v-layout>
            </v-container>
          </div>
        </v-form>

        <v-btn color="primary" @click="nextStep">Continue</v-btn>
      </v-stepper-content>

      <v-stepper-step :complete="e1 > 2" step="2">GROUP</v-stepper-step>
      <v-stepper-content step="2">
        <v-form ref="form_2" v-model="form_2_validation" lazy-validation data-vv-scope="form_2">
          <v-layout wrap align-center>
            <v-flex xs12 sm6 d-flex>
              <v-radio-group v-model="form.group_type" light>
                <v-radio color="primary" label="Open" value="1"></v-radio>
                <v-radio v-if="destination.trip_type==2" color="primary" label="Private" value="2"></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
        </v-form>

        <v-btn class="ml-0" color="primary" @click="nextStep">Continue</v-btn>
        <v-btn flat @click="e1 = e1-1">Back</v-btn>
      </v-stepper-content>

      <v-stepper-step :complete="e1 > 3" step="3">PARTICIPANTS</v-stepper-step>
      <v-stepper-content step="3">
        <v-form ref="form_3" v-model="form_3_validation" lazy-validation data-vv-scope="form_3">
          <v-container fluid px-2>
            <v-layout wrap align-center>

              <v-flex xs12 sm6 d-flex>
                <v-select :items="[1,2,3,4,5,6]" box label="Number of participants" v-model="val_num_participants" required></v-select>
              </v-flex>

            </v-layout>
          </v-container>

          <v-container fluid px-2 v-for="(participant, n) in form.participants" :key="n">
            <v-divider></v-divider>
            <p class="mt-2 font-weight-bold">Participant {{ parseInt(n)+1 }}</p>
            <v-layout wrap align-center>
              <v-flex xs12 d-flex>
                <v-container fluid grid-list-lg pa-0>
                  <v-layout row wrap>

                    <v-flex xs12 sm6>
                      <!-- First Name -->
                      <text-input :form="form" :label="$t('name_first')" :v-errors="errors" :value.sync="form.participants[n].name_first" :name="'First name' + parseInt(n)+1" :scope="'form_3'" v-validate="'required'"></text-input>
                    </v-flex>

                    <v-flex xs12 sm6>
                      <!-- Last Name -->
                      <text-input :form="form" :label="$t('name_last')" :v-errors="errors" :value.sync="form.participants[n].name_last" :name="'Last name' + parseInt(n)+1" :scope="'form_3'" v-validate="'required'"></text-input>
                    </v-flex>

                    <v-flex xs12 md6>
                      <!-- Email -->
                      <email-input :form="form" :label="$t('email')" :v-errors="errors" :value.sync="form.participants[n].email" :name="'Email' + parseInt(n)+1" :scope="'form_3'" v-validate="'required|email'" box></email-input>
                    </v-flex>

                  </v-layout>
                </v-container>

              </v-flex>

            </v-layout>
          </v-container>
        </v-form>

        <v-btn color="primary" @click="nextStep">Continue</v-btn>
        <v-btn flat @click="e1 = e1-1">Back</v-btn>
      </v-stepper-content>

      <v-stepper-step :complete="e1 > 4" step="4">SUMMARY</v-stepper-step>
      <v-stepper-content step="4">
        <v-form ref="form_4" v-model="form_4_validation" lazy-validation data-vv-scope="form_4">
          <v-container fluid pa-0 mb-5>
            <v-layout>
              <v-flex xs12 lg6>
                <h3 class="mb-3">{{ destination.name }}</h3>

                <p class="mb-0"><span class="font-weight-bold">Arrival date: </span>{{ form.date_from }}</p>
                <p><span class="font-weight-bold">Departure date: </span>{{ form.date_to }}</p>
                <p><span class="font-weight-bold">Group: </span>{{ (form.group_type==2 ? 'Private' : 'Open') }}</p>

                <h4>Participants</h4>
                <p class="mb-0" v-for="(participant, p_index) in form.participants" :key="p_index">{{ participant.name_first }} {{ participant.name_last}} - {{ participant.email }}</p>

                <h3 class="mt-3">Estimated Price</h3>
                <div v-if="trip_price && trip_price.length>0 && trip_price[0].amount_total_incl_vat">
                  <p>From {{ trip_price[0].amount_total_incl_vat }} EUR*</p>
                  <p>*Rental gear and trip upgrades is not included in the estimated price.</p>
                </div>
                <p v-else>The price cannot be estimated. Send in your booking request and we will contact you as soon as possible with the price.</p>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12 lg6>
                <v-container fluid grid-list-lg pa-0>
                  <v-layout row wrap>
                    <v-flex xs12 md6>
                      <!-- First Name -->
                      <text-input :form="form" :label="$t('name_first')" :v-errors="errors" :scope="'form_4'" :value.sync="form.customer_name_first" :name="'First name'" v-validate="'required'"></text-input>
                    </v-flex>
                    <v-flex xs12 md6>
                      <!-- Last Name -->
                      <text-input :form="form" :label="$t('name_last')" :v-errors="errors" :scope="'form_4'" :value.sync="form.customer_name_last" :name="'Last name'" v-validate="'required'" solo></text-input>
                    </v-flex>
                  </v-layout>
                </v-container>
                <!-- Email -->
                <email-input :form="form" :label="$t('email')" :v-errors="errors" :scope="'form_4'" :value.sync="form.customer_email" :name="'Email'" v-validate="'required|email'" box></email-input>
              </v-flex>
            </v-layout>
          </v-container>

          <v-btn class="ml-0" color="primary" @click="submit_request">{{ $t('send_booking_request') }}</v-btn>
          <v-btn flat @click="e1 = e1-1">Back</v-btn>
        </v-form>
      </v-stepper-content>

    </v-stepper>

  </div>
  <div v-else-if="data_fetched">
    <h1>Sorry!</h1>
    <h4>This trip is no longer available or currently not open for bookings.</h4>
  </div>
</template>

<script>
import Login from '~/pages/auth/login'
import { mapGetters } from 'vuex'
import Form from 'vform'
import axios from 'axios'

export default {
  name: 'request-view',
  layout: 'default',
  data: () => ({
    api_headers: {'API-KEY': 'A000001-1qaz2wsx-3fhd4gdj'},
    booking_request_submitted: false,
    destination_id: 0,
    destinations: null,
    destination: null,
    trip: null,
    val_trip_week: null,
    val_trip_date: null,
    val_trip: null,
    val_num_participants: 1,
    form_1_validation: null,
    form_2_validation: null,
    form_3_validation: null,
    form_4_validation: null,
    modal_date_from: false,
    modal_date_to: false,
    form: new Form({
      trip_id: 0,
      group_type: "1",
      date_from: null,
      date_to: null,
      participants: [
        {
          "name_first":"",
          "name_last":"",
          "email":""
        }
      ],
      customer_name_first:"",
      customer_name_last:"",
      customer_email:""
    }),
    trip_price: null,
    e1: 1,
    busy: false,
    data_fetched: false,
  }),
  computed: {
    ...mapGetters({
      authenticated: 'authCheck',
    }),
    select_weeks: function(){
      let arr = [];
      let add_week = false;
      if(this.trip.price_periods){
        var today = new Date();
        var date_from;
        for(let y_w in this.trip.price_periods){
          add_week = false;
          for(let date in this.trip.price_periods[y_w]["dates"]){
            date_from = new Date(this.trip.price_periods[y_w]["dates"][date].date_from);
            if (today <= date_from) {
              add_week = true;
            }
          }
          if(add_week){
            arr.push({"text":this.trip.price_periods[y_w].label, "value":y_w});
          }
        }
      }
      return arr;
    },
    select_dates: function(){
      let arr = [];
      if(this.val_trip_week && this.trip.price_periods){
        var today = new Date();
        var date_from;
        for(let date in this.trip.price_periods[this.val_trip_week]["dates"]){
          date_from = new Date(this.trip.price_periods[this.val_trip_week]["dates"][date].date_from);
          if (today <= date_from) {
            arr.push({"text":this.trip.price_periods[this.val_trip_week]["dates"][date].label, "value":{"date_from":this.trip.price_periods[this.val_trip_week]["dates"][date].date_from, "date_to":this.trip.price_periods[this.val_trip_week]["dates"][date].date_to}});
          }
        }
        arr.push({"text":"Select you own dates", "value":"999"});
      }
      return arr;
    },
    select_trips: function(){
      let arr = [];
      if(this.destination && this.destination.trips.length>0){
        var today = new Date();
        var date_from;
        for(let t_index in this.destination.trips){
          date_from = new Date(this.destination.trips[t_index].date_from);
          if (today < date_from) {
            arr.push({"text":this.destination.trips[t_index].date_from + ' - ' + this.destination.trips[t_index].date_to, "value":{"trip":this.destination.trips[t_index], "date_from":this.destination.trips[t_index].date_from, "date_to":this.destination.trips[t_index].date_to}});
          }
        }
      }
      return arr;
    },
    select_date_from_min: function(){
      var today = new Date();
      var date_from = new Date(this.trip.date_from);
      if (today <= date_from) {
        return this.trip.date_from;
      } else {
        return today.toISOString().substring(0, 10);
      }
    },
    select_date_from_max: function(){
      if(this.form.date_to){
        return this.form.date_to;
      } else {
        return this.trip.date_to;
      }
    },
    select_date_to_min: function(){
      if(this.form.date_from){
        return this.form.date_from;
      } else {
        var today = new Date();
        var date_from = new Date(this.trip.date_from);
        if (today <= date_from) {
          return this.trip.date_from;
        } else {
          return today.toISOString().substring(0, 10);
        }
      }
    },
    select_date_to_max: function(){
      return this.trip.date_to;
    }
  },
  mounted() {
    this.busy = true
    this.form.trip_id = this.$route.query.trip
    this.destination_id = this.$route.query.destination
    this.fetch_data();
  },
  watch: {
    e1: function(e1){
      if(e1==4){
        this.calculate_price();
      }
    },
    val_num_participants: function(num_participants){
      let arr = [];
      for(let i = 0; i < num_participants; i++){
        if(i in this.form.participants){
          arr.push({"name_first":this.form.participants[i].name_first,"name_last":this.form.participants[i].name_last,"email":this.form.participants[i].email})
        } else {
          arr.push({"name_first":"","name_last":"","email":""})
        }
      }
      this.form.participants = arr;
    },
    val_trip_date: function(val){
      if(val=='999'){
        this.form.date_from = null;
        this.form.date_to = null;
      } else {
        this.form.date_from = val.date_from;
        this.form.date_to = val.date_to;
      }
    },
    val_trip: function(val){
      this.trip = val.trip;
      this.form.trip_id = val.trip.trip_id;
      this.form.date_from = val.trip.date_from;
      this.form.date_to = val.trip.date_to;
    },
  },
  methods: {
    async nextStep () {
      this.$validator.validateAll('form_'+this.e1).then((result) => {
        if (result) {
          this.e1++
        }
      });
    },
    async fetch_data(){
      this.busy = true;
      if(this.form.trip_id>0){
        await axios.get(process.env.API_URL+'/trips/' + this.form.trip_id,{'headers':this.api_headers})
        .then((response) => {
          this.trip = response.data.trip;
        })
        .catch((error) => {
        })
        await axios.get(process.env.API_URL+'/destinations/' + this.destination_id,{'headers':this.api_headers})
        .then((response) => {
          if(response.data.destination){
            this.destination = response.data.destination;
          } else if(response.data.destinations){
            this.destinations = response.data.destinations;
          }
        })
        .catch((error) => {
        })
      } else {
        await axios.get(process.env.API_URL+'/destinations/' + this.destination_id,{'headers':this.api_headers})
        .then((response) => {
          if(response.data.destination){
            this.destination = response.data.destination;
          } else if(response.data.destinations){
            this.destinations = response.data.destinations;
          }
        })
        .catch((error) => {

        })
      }
      this.busy = false
      this.data_fetched = true
    },
    calculate_price () {
      this.busy = true
      axios.post(process.env.API_URL+'/calculate_price', this.form, {'headers':this.api_headers})
        .then((response) => {
          if(response.data.price){
            this.trip_price = response.data.price
          } else if(response.data.error) {
            //this.formError = data.error
          } else {
            //this.formError = "Sorry, somthing went wrong. Please reload the page and try again."
          }
          this.busy = false
        })
        .catch((error) => {
          this.busy = false
        })
    },
    submit_request () {
      this.$validator.validateAll('form_'+this.e1).then((result) => {
        if (result) {
          this.busy = true
          axios.post(process.env.API_URL+'/booking_request', this.form, {'headers':this.api_headers})
            .then((response) => {
              if(response.data.success){
                this.booking_request_submitted = true;
              } else if(response.data.error) {
                this.formError = response.data.error
              } else {
                this.formError = "Sorry, somthing went wrong. Please try again later."
              }
              this.busy = false
            })
            .catch((error) => {
              this.busy = false
            })
          }
        })
    },
  },
  metaInfo () {
    return { title: this.$t('home') }
  }
}
</script>



// WEBPACK FOOTER //
// request.vue?883660e2